// Action key that carries API call info interpreted by this Redux middleware.
export const CALL_API = "CALL_API";
